import { useEffect } from 'react';

import { AuthService } from 'shared/lib/keycloak';
import { useUserOrgs } from 'shared/api/onboarding';

import { createSfScriptTag, getPrechatData } from './salesforce-chat.utils';

export const useSalesforceChat = () => {
  const { isLoading: isUserOrgsLoading, schools, districts } = useUserOrgs();

  useEffect(() => {
    if (AuthService.isReviewer() || isUserOrgsLoading) return;

    const prechatData = getPrechatData({ schools, districts });
    const script = createSfScriptTag(prechatData);

    return () => {
      document.body.removeChild(script);
    };
  }, [isUserOrgsLoading, schools, districts]);
};
